
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        color: {
            type: [String, null] as PropType<string | null>,
            default: null
        }
    }
})
